export default "__VITE_ASSET__C3R48FjQ__"